import { SHOW_ALERT, HIDE_ALERT } from 'constants/ActionTypes';

const initState = {
  showAlert: false,
  alertMessage: '',
  alertAction: () => null,
};
export default (
  state = initState,
  action,
) => {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        showAlert: true,
        alertMessage: action.message,
        alertAction: action.action,
        alertActionLabel: action.alertActionLabel,
        alertCancelLabel: action.alertCancelLabel,
      };
    case HIDE_ALERT:
      return {
        ...initState,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/Notification.js